<template>
    <div class="indonesian_leadership_training">
        <div :class="['page_header', language == 'en' ? 'page_header_en' : '']">
            <div class="header_inner">
                <img src="../img/indonesian_leadership/LOGO.png" alt="" class="logo">

                <div class="user_center clearfix">
                    <div class="user-con" v-show="!isLogin">
                        <span class="login-btn" @click="loginFun()">{{ $t("message.login") }}</span>
                        <span> | </span>
                        <span class="register-btn">{{ $t("message.register") }}</span>
                    </div>

                    <div class="login-con" v-show="isLogin"  @click="showUserInfo()">
                        {{user.username}}
                        <span @click="loginOut()">{{language == 'cn' ? '退出' : 'logout'}}</span>
                    </div>
                </div>

                <div class="change_lan" @click="changeLanguage()">
                    <span class="lang-con">{{languageContent}}</span>
                </div>
            </div>
        </div>
        <!-- <div class="guset_wrap">
            <div class="cover_wrap">
                <img src="../img/indonesian_leadership/footer.png" alt="" class="cover">
                <img src="../img/indonesian_leadership/play_button.png" alt="" class="play_btn" v-if="liveDetail.status == 1 && liveDetail.customStatus == 0 && liveDetail.isOrder == false" @click="join(liveDetail, liveIndex, false)">
                <img src="../img/indonesian_leadership/play_button.png" alt="" class="play_btn" v-else-if="liveDetail.status == 3" @click="replay(liveDetail.video_url)">
                <img src="../img/indonesian_leadership/play_button.png" alt="" class="play_btn" v-else-if="liveDetail.status == 1 && liveDetail.customStatus == 1" @click="joinToLive(liveDetail, liveIndex)">
                <img src="../img/indonesian_leadership/play_button.png" alt="" class="play_btn" v-else>
            </div>

            <div class="guest_info">
                <div class="time">{{new Date(liveDetail.start_time).Format('YYYY.MM.DD')}}</div>
                <div class="video_name">{{language == 'cn' ? liveDetail.name : liveDetail.name_en}}</div>
                <div class="guest_name_con">
                    <div class="guest_benqi">授课专家：</div>
                    <div class="guest_name">
                    {{language == 'cn' ? liveDetail.teacher_name : liveDetail.teacher_name_en}}
                    <span class="guest_title">{{language == 'cn' ? liveDetail.organization_name : liveDetail.organization_name_en}}</span>
                    </div>
                </div>
                <div class="video_desc">
                </div>
            </div>
        </div> -->
        <div class="course_con">
            <div class="course_title">课程</div>
            <ul class="course_list">
                <li v-for="(v, i) in courseList" :key="i" @click="getLiveDetail(v, i)">
                    <div class="course_status" v-show="v.customStatus == 0">
                        {{new Date(v.start_time).Format('MM.DD hh:mm')}}
                        <span class="hour">{{(v.end_time - v.start_time) /1000/60/60}} h</span>
                    </div>
                    <div class="course_status course_now" v-show="v.customStatus == 1">
                        {{language == 'cn' ? '正在直播' : 'Live Broadcasting'}}
                    </div>
                    <div class="course_status course_end" v-show="v.customStatus == 2 && v.status != 3">
                        {{language == 'cn' ? '直播已结束' : 'Live broadcast has ended'}}
                    </div>
                    <div class="course_status course_end" v-show="v.customStatus == 2 && v.status == 3">
                        {{language == 'cn' ? '课程回放' : 'Course Playback'}}
                    </div>
                    <img :src="v.cover_url" alt="" class="course_cover">
                    <div class="course_bottom">
                        <div class="course_name">{{language == 'cn' ? v.name : v.name_en}}</div>
                        <div class="author_info">
                            <div class="name_con">
                                <div class="name">{{language == 'cn' ? v.teacher_name : v.teacher_name_en}}</div>
                                <!-- <div class="touxian">{{language == 'cn' ? v.teacher_title : v.teacher_title_en}}</div> -->
                            </div>
                            <div class="jigou">{{language == 'cn' ? v.organization_name : v.organization_name_en}}</div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div class="footer">

        </div>

        <!-- <transition name="fade">
            <div id="videoPlayWrapper" v-if="isPlay">
                <div class="videoContent">
                    <div class="closeVideo" @click="closeVideo()">×</div>
                    <ali-player
                    v-if="isPlay"
                    :useFlashPrism="false"
                    :useH5Prism='true'
                    :autoplay="true"
                    :isLive="false"
                    :rePlay="false"
                    :showBuffer="true"
                    showBarTime="5000"
                    width="80%" 
                    height="700px" 
                    controlBarVisibility="always"
                    source="https://video.chineseplus.net/zt/20210611_%E5%BF%97%E6%84%BF%E8%80%85%E6%B4%BE%E9%81%A3%E5%B7%A5%E4%BD%9C%E8%AF%B4%E6%98%8E.mp4"></ali-player>
                </div>
            </div>
        </transition> -->
    </div>
</template>

<script>
import Qs from 'qs'
import aliPlayer from '../pc/aliplayer'

export default {
  data () {
    return {
      isLogin: false,
      userInfoShow: false,
      languageContent: 'Chinese',
      languageMap: {
        'cn': 'English',
        'en': 'Chinese'
      },
      liveDetail: {},
      liveIndex: '',
    isPlay: false,
    currentVideoUrl: '',
    user: {
        username: '',
        email: ''
    },
    subject_info: {},
    courseList: [],
    subject_id: null,
    beforeTime: 30, // 提前可进入直播间时间
    afterTime: 30 // 延后关闭直播间时间
    }
  },
  components: {
    aliPlayer
  },
  computed: {
    language () {
      return this.$i18n.locale
    }
  },
  created () {
    localStorage.setItem('localeLanguage', 'en')
    this.languageContent = this.languageMap[this.language]
    this.customCheckLogin()
    this.getCourseInfo()
  },
  methods: {
    customCheckLogin() {
        this.checkLogin().then(res => {
            if(res.data.success){
                this.isLogin = true
                this.user = res.data.data
            } else {
                this.isLogin = false
            }
        }).catch((r) => {
            console.log(r)
        })
    },
    // 点击弹出框 用户信息
    showUserInfo () {
      this.userInfoShow = !this.userInfoShow
    },
    // 登录
    loginFun () {
        window.location.href = 'https://z.chineseplus.net/' + "user/api/login?" + "callback=" + encodeURIComponent(window.location.href);
    },
    // 退出登录
    loginOut () {
      this.$utils.get('/user/api/logout', { }).then (res => {
        if (res.data.success) {
          window.location.reload()
        }
      })
    },
    // 切换语言
    changeLanguage () {
      const data = localStorage.getItem('localeLanguage') == 'cn' ? 'en' : 'cn'
      localStorage.setItem('localeLanguage', data)
    //   let data = this.language == 'cn' ? 'en' : 'cn'
      this.$i18n.locale = data
      this.languageContent = this.languageMap[data]
    //   location.reload()
    },
    // 点击获取直播详情
    getLiveDetail (v, i) {
        this.liveDetail = v
        this.liveIndex = i
        this.$router.push({
            path: '/m_page/m_indonesian_leadership_training_detail',
            query: {
                id: v.id
            }
        })
    },
    // 获取课程列表
    getCourseInfo(id) {
        this.$utils.get('/subject/lesson/getlist', {
            // subject_id: 117,
            subject_id: 130,
            limit: 200
        }).then(res => {
            if(res.data.success) {
                var now = new Date().getTime()
                var endTime = now - this.afterTime * 60 * 1000;
                var nowBeforeFiveMin = now + this.beforeTime * 60 * 1000
                res.data.data.list.forEach(e => {
                    e.isOrder = false
                    e.customStatus = 0
                    if (nowBeforeFiveMin > e.start_time) {
                        e.customStatus = 1 // 0:直播未开始 1:正在直播 2：直播已结束
                    }
                    if (endTime > e.end_time) {
                        e.customStatus = 2
                    }
                    if (e.extra) {
                        e.teacher_des = e.extra.teacher_des
                        e.teacher_des_en = e.extra.teacher_des_en
                    } else {
                        e.teacher_des = ''
                        e.teacher_des_en = ''
                    }
                })
                this.courseList = res.data.data.list
                // this.courseList = res.data.data.list.slice(0, 3)
                
                this.liveDetail = this.courseList[0]
                // this.checkOrderList()
            }
        }).catch((r) => {
            console.log(r)
        })
    },
    // 检查可预约直播间
    checkOrderList() {
        const orderRoomId = []
        this.courseList.forEach(e => {
            if (orderRoomId.indexOf(e.room_id) == -1 && e.room_id != 0) {
                orderRoomId.push(e.room_id)
            }
        })
        this.checkRoomsIsOrder(orderRoomId)
    },
    // 检查用户直播间状态
    checkRoomsIsOrder(arr) {
        const data = Qs.stringify({
            rooms: arr.toString(),
            user: this.user.email
        })
        this.$utils.thirdPost('https://mooc-stage.chinesecio.com/api/live/get_user_rooms'+"?time=" +new Date().valueOf(), data, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(res => {
            if (res.data.code == 0) {
                this.courseList.forEach((e, index) => {
                    if (res.data.data.hasOwnProperty(e.room_id)) {
                        this.courseList[index].isOrder = true
                        this.$set (this.courseList, index, this.courseList[index])
                    }
                })
            }
        }).catch((r) => {
            console.log(r)
        })
    },
    join(item, index, islive) {
        if(!this.isLogin) {
            this.toLogin()
            return
        }
        const data = Qs.stringify({
            room_id: item.room_id,
            user: this.user.email,
            secret: "03198325b8b61ccc3413cf7e754febea",
            key: "zyz",
            username: this.user.username,
            realname: this.user.username
        })
        this.$utils.thirdPost('https://mooc-stage.chinesecio.com/api/live/add_user'+"?time=" +new Date().valueOf(), data, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(res => {
            if (res.data.code == 0) {
                this.courseList[index].isOrder = true
                this.$set (this.courseList, index, this.courseList[index])
                if (islive) {
                    window.location.href = 'https://mooc-stage.chinesecio.com/index/login/index.html?room_id=' + item.room_id
                }
            }
        }).catch((r) => {
            console.log(r)
        })
    },
    joinToLive(item, index) {
        if(!this.isLogin) {
            this.toLogin()
            return
        }
        if(!item.isOrder) {
            this.join(item, index, true)
        }else {
            window.location.href = 'https://mooc-stage.chinesecio.com/index/login/index.html?room_id=' + item.room_id
        }
    },
    replay(url) {
        this.isPlay = true
        this.currentVideoUrl = url
    },
    closeVideo() {
        this.isPlay = false
    },
  }
}
</script>

<style scoped lang="scss">
.indonesian_leadership_training {
    width: 100%;
    // height: 100%;
    position: relative;
    font-family: 'Microsoft YaHei';
    background: #e6e6e6;
    .page_header {
        padding: 0 .44rem;
        padding-top: .47rem;
        box-sizing: border-box;
        width: 100%;
        height: 5.54rem;
        background: url('../img/indonesian_leadership/m/banner.png') no-repeat center;
        background-size: cover;
        &.page_header_en {
            background: url('../img/indonesian_leadership/m/banner_en.png') no-repeat center;
            background-size: cover;
        }
        .header_inner {
            margin: auto;
            .logo {
                width: 2.45rem;
                float: left;
            }
            .change_lan {
                float: right;
                width: 2rem;
                height: .6rem;
                background-color: #d9b47f;
                border-radius: .04rem;
                color: #fff;
                text-align: center;
                line-height: .6rem;
                cursor: pointer;
                font-size: .39rem;
            }
            .user_center {
                float: right;
                font-size: .39rem;
                padding-top: .1rem;
                .user-con {
                    float: left;
                    margin-left: .3rem;
                    color: #a17e4b;
                    .login-btn {
                    cursor: pointer;
                    }
                    .register-btn {
                    cursor: pointer;
                    }
                }
                .login-con {
                    float: left;
                    margin-left: .5rem;
                    margin-right: .4rem;
                    position: relative;
                    span {
                        cursor: pointer;
                        padding-left: .1rem;
                    }
                    .user-img {
                    width: 30px;
                    border: 1px solid #f5f5f5;
                    padding: 3px;
                    border-radius: 50%;
                    vertical-align: middle;
                    cursor: pointer;
                    }
                    .user-box {
                    border: 1px solid #ccc;
                    position: absolute;
                    top: 45px;
                    right: -20px;
                    font-size: 18px;
                    width: 90px;
                    line-height: 30px;
                    overflow: hidden;
                    display: block;
                    border-radius: 5px;
                    text-align: center;
                    & li {
                        display: inline-block;
                        width: 100%;
                        height: 30px;
                        color: #009dcd;
                        background: #fff;
                        cursor: pointer;
                    }
                    }
                }
            }
        }

    }

    .guset_wrap {
      width: 100%;
      background: url('../img/indonesian_leadership/qi_bg.png') no-repeat right;
      width: 1230px;
      margin: auto;
      margin-top: 90px;
      .cover_wrap {
        width: 730px;
        height: 402px;
        display: inline-block;
        background-color: #ff9646;
        border: solid 10px #ff9646;
        border-radius: 20px;
        position: relative;
        // left: -15px;
        top: -65px;
        .cover {
          width: 100%;
          height: 100%;
          border-radius: 10px;
        }
        .play_btn {
          position: absolute;
          left: 50%;
          margin-left: -50px;
          bottom: -40px;
          cursor: pointer;
        }
      }

      .guest_info {
        float: right;
        width: 410px;
        margin-top: 87px;
        margin-right: 30px;
        .time {
          font-size: 18px;
          color: #036eb8;
          margin-bottom: 23px;
        }
        .video_name {
          font-weight: bold;
          font-size: 30px;
          color: #3c3c3c;
          margin-bottom: 30px;
          line-height: 1.2;
        }
        .guest_name_con {
          .guest_benqi {
            font-size: 16px;
            color: #1f1f3b;
            margin-bottom: 14px;
          }
          .guest_name {
            font-size: 24px;
            color: #036eb8;
            font-weight: bold;
            margin-bottom: 40px;
            .guest_title {
              font-weight: normal;
              font-size: 18px;
            }
          }
        }
        .video_desc {
          font-size: 14px;
          line-height: 24px;
          color: rgba(0, 0, 0, .8);
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 6;
          -webkit-box-orient: vertical;
          /deep/ div {
            max-height: 144px;
            strong {
              font-weight: bold;
            }
            h1,h2,h3,h4,h5,h6 {
              font-weight: bold;
              font-size: 14px;
              margin-bottom: 20px;
            }
            table tr,td {
              border: 1px solid #ccc;
            }
            p {
              // text-indent: 2em;
              line-height: 24px;
              margin-bottom: 30px;
              a {
                color: #0000ff;
              }
              strong {
                  font-weight: bold;
              }
              em {
                  font-style: italic;
              }
              img {
                  max-width: 800px;
                  text-indent: 0;
                  margin-bottom: 0px;
                  margin-left: -1em;
              }
              h1,h2,h3,h4,h5,h6 {
                font-weight: bold;
              }
              span {
                // color: rgba(0, 0, 0, .8);
              }
            }
          }
        }
      }
    }
    .course_con {
        position: relative;
        margin: auto;
        padding: 0 .44rem;
        // margin-bottom: .67rem;
        .course_title {
            font-size: .45rem;
            color: #262525;
            font-weight: bold;
            // margin-top: 50px;
            margin-bottom: .3rem;
        }
        .course_list {
            overflow: hidden;
            li {
                width: calc((100% - .30rem)/2);
                // height: 5.31rem;
                background-color: #ffffff;
                border-radius: .15rem;
                border: solid .01rem #cbd1da;
                overflow: hidden;
                float: left;
                margin-right: .16rem;
                position: relative;
                cursor: pointer;
                margin-bottom: .35rem;
                &:nth-child(2n) {
                    margin-right: 0;
                }
                .course_status {
                    font-size: .27rem;
                    color: #ffffff;
                    text-align: center;
                    line-height: .6rem;
                    position: absolute;
                    left: 0;
                    top: 0;
                    background-color: #1f67c6;
	                border-radius: 0px .2rem .2rem 0px;
                    padding: 0 .23rem;
                    box-sizing: border-box;
                    &.course_end {
                        background-color: #cdcdcd;
                    }
                    &.course_now {
                        background-image: linear-gradient(90deg, 
                        #ff713e 0%, 
                        #ffba4e 100%), 
                    linear-gradient(
                        #cdcdcd, 
                        #cdcdcd);
                    background-blend-mode: normal, 
                        normal;
                    }
                    .hour {
                        padding-left: 5px;
                    }
                }
                .course_cover {
                    width: 100%;
                    height: 2.83rem;
                    display: block;
                }
                .course_bottom {
                    height: 2.3rem;
                    padding: 0 .28rem;
                    box-sizing: border-box;
                    .course_name {
                        font-size: .36rem;
                        color: #303031;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        line-height: 1.3;
                        margin-top: .32rem;
                        margin-bottom: .3rem;
                    }
                    .author_info {
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        .name_con {
                            overflow: hidden;
                            margin-bottom: .15rem;
                            .name {
                                font-size: .36rem;
                                color: #303031;
                                // display: inline-block;
                                margin-right: .1rem;
                                float: left;
                            }
                            .touxian {
                                font-size: .36rem;
                                color: #303031;
                                // display: inline-block;
                                float: left;
                            }
                        }
                        .jigou {
                            font-size: .3rem;
                            color: #848484;
                            // display: inline-block;
                        }
                    }
                }
            }
        }
    }
    .footer {
        background: url('../img/indonesian_leadership/m/footer.png') no-repeat center;
        background-size: 100% 100%;
        height: 2.7rem;
        // position: fixed;
        // bottom: 0;
        // width: 100%;
    }
    #videoPlayWrapper {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.8);
        z-index: 999;
        }
    #videoPlayWrapper .closeVideo {
        position: absolute;
        right: 20px;
        top: 10px;
        font-size: 50px;
        color: #fff;
        cursor: pointer;
    }
    .videoContent {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>
